import {
  AssetPresentationRatioEnum,
  findByTypeV2,
  getTypesByRatio,
  KuxFilteredCategoriesDTO,
  UIDAPresentationTypeEnum,
  UIDAStructureTypeEnum,
} from '@kaltura-ott/tvpil';
import { observable } from 'mobx';
import { singleton } from 'tsyringe';

import { EntitiesType, Linear, LinkAsAsset, Person, Logo } from '../entities';

@singleton()
export class TopShelfStore {
  @observable currentAsset?: EntitiesType;
  uiDesignElements?: KuxFilteredCategoriesDTO['uiDesignElements'];
  private imageType?: number;

  constructor(tree: KuxFilteredCategoriesDTO) {
    const asideFolder = tree.children.find((child) => child.type === UIDAStructureTypeEnum.aside);
    const topShelfTree = asideFolder?.children.find((aside) => aside.subtype === UIDAPresentationTypeEnum.top_shelf);

    if (topShelfTree) {
      this.imageType = topShelfTree.railImageProperty.assetPresentationImageType;
      this.uiDesignElements = topShelfTree.uiDesignElements;
    }
  }

  async setAsset(asset: EntitiesType) {
    if (!asset) {
      return;
    }

    this.currentAsset = asset;

    if (
      this.currentAsset instanceof LinkAsAsset ||
      this.currentAsset instanceof Person ||
      this.currentAsset instanceof Logo
    ) {
      return;
    }

    await this.currentAsset.setupRules();
  }

  itemImage() {
    if (!this.currentAsset || !this.imageType) {
      return;
    }
    const assetData = this.currentAsset.data;
    const image = findByTypeV2(assetData, this.imageType);

    if (image) {
      return {
        imageUrl: image.url,
        isBlurred: false,
      };
    } else {
      const types = getTypesByRatio(AssetPresentationRatioEnum['16x9']);
      const type = types.find((type) => {
        return findByTypeV2(assetData, type.id);
      });

      if (!type) {
        return;
      }

      const image = findByTypeV2(assetData, type.id);

      return {
        imageUrl: image?.url,
        isBlurred: true,
      };
    }
  }

  get isAdult(): boolean | undefined {
    if (!this.currentAsset) {
      return false;
    }

    if (
      this.currentAsset instanceof LinkAsAsset ||
      this.currentAsset instanceof Person ||
      this.currentAsset instanceof Logo
    ) {
      return false;
    }

    if (this.currentAsset instanceof Linear) {
      return this.currentAsset.data.adult;
    }
    return this.currentAsset.isAdult;
  }

  get isGeoBlocked(): boolean | undefined {
    if (!this.currentAsset) {
      return false;
    }

    if (
      this.currentAsset instanceof LinkAsAsset ||
      this.currentAsset instanceof Person ||
      this.currentAsset instanceof Logo
    ) {
      return false;
    }

    return this.currentAsset.isGeoBlocked;
  }

  resetStore() {
    this.currentAsset = undefined;
  }
}
